<!--
 * @创建文件时间: 2019-12-21 20:36:52
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-05-05 16:00:47
 * @联系Qq:1638245306
 * @文件介绍: 附件-文件上传
 -->
<template>
    <div>
        <el-upload
                :ref='refName'
                :action="actionUrl"
                :data="params"
                :headers="myHeaders"
                :disabled="canDel==3 || allowUpload"
                :file-list="fileList"
                :show-file-list="false"
                :on-progress="onProgress"
                :on-preview="handlePictureCardPreview"
                :on-success='successHandle'
                :on-error="errorHandle"
                multiple
        >
            <el-button  icon="el-icon-plus" size="small" type="primary"   :disabled="canDel==3 || allowUpload" :loading="uploadLoading">{{uploadLoading?'上传中':'点击上传'}}</el-button>
        </el-upload>
        <div>
            <div v-for="(item,index) in fileList" :key="index">
                <span><i class="el-icon-document"></i>{{item.name}}</span>
                <span @click="onRemove(index)" style="color: #ff0000;margin-left: 5px;cursor: pointer;" v-if="canDel==1 || canDel==2">[删除]</span>
                <span @click="downLoad(item.url)" style="color: #00aeef;margin-left: 5px;cursor: pointer;">[下载]</span>
            </div>
        </div>
    </div>
</template>
<script>
    import util from "@/libs/util";

    export default {
        data() {

            return {
                refName: '',
                imgVisible: false,
                uploadLoading:false,
                fileList: [],
                dialogImageUrl: '',
                actionUrl: "",
                myHeaders:{

                },
                params: {
                    path: ''
                },
                thisFileUrl: this.fileUrl,
                fileHttp: "",
                filelistShow: false
            };
        },
        model: {
            prop: 'fileUrl'

        },
        props: {
            fileUrl: {
                type: String,
                default: ''
            },
            canDel:{
                type: Number,
                default: 1
            },
            path:{
                type:String,
                default:''
            },
            fileType:{
                type:String,
                default:'file'
            }
        },
        watch: {
            fileList: {
                immediate:true,
                handler (nv, ov) {
                    let $this = this
                }
            },
            fileUrl: {
                immediate:true,
                handler (nv, ov) {
                    if (this.Tools.get().StringTools.isNullOrEmpty(nv)){
                        this.fileList = []
                    }else {
                        this.thisFileUrl = nv
                        try {
                            const cache = JSON.parse(nv)
                            if (Array.isArray(cache)){
                                this.fileList = cache
                            }
                        }catch (e) {

                        }
                    }
                }
            },
            canDel(nv,ov){

                if(nv==1){
                    this.fileUrl = ""
                    this.thisFileUrl = ""
                }
            }
        },
        methods: {
            getUserToken(){
                let token = util.session.get("token")
                this.myHeaders = {
                    userToken:token
                }
            },
            //点击上传
            submitUpload() {
                let refName = this.refName
                this.$refs[refName].submit();
            },
            onProgress(event, file, fileList){
                this.uploadLoading = true
            },
            //成功后的回调
            successHandle(response, file, fileList) {
                if (response.resultCode !== 2000) {
                    this.fileList = []
                    this.uploadLoading = false
                    this.$message.error("文件上传失败")
                } else {

                    this.uploadLoading = false
                    let data = JSON.parse(response.data)
                    let img = data.img
                    let fileUrl = img.substring(0, img.length - 1)
                    this.thisFileUrl =  fileUrl
                    let list = [{name: file.name, url: this.thisFileUrl}]
                    this.fileList = list
                    if (typeof this.fileList === 'undefined' || this.fileList.length === 0){
                        this.$emit('input', '')
                    }else{
                        this.$emit('input', JSON.stringify(this.fileList))
                    }
                }
            },
            //失败后的回调
            errorHandle(response, file, fileList) {

            },
            //文件删除
            onRemove(index) {

                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    closeOnClickModal:false
                }).then(() => {
                    this.fileList.splice(index,1)
                    this.uploadLoading = false
                    this.thisFileUrl = ""
                    if (typeof this.fileList === 'undefined' || this.fileList.length === 0){
                        this.$emit('input', '')
                    }else{
                        this.$emit('input', JSON.stringify(this.fileList))
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.imgVisible = true;
            },
            //验证文件格式
            beforeAvatarUpload(file) {

                var isFile;
                var imgType = file.name.substring(file.name.lastIndexOf('.') + 1)

                switch (imgType) {
                    case 'doc':
                        isFile = true
                        break;
                    case 'docx':
                        isFile = true
                        break;
                    case 'pdf':
                        isFile = true
                        break;
                    case 'xls':
                        isFile = true
                        break;
                    case 'xlsx':
                        isFile = true
                        break;
                    default:
                        isFile = false
                }
                if (!isFile) {
                    this.$message.error('文件类型为Word,PDF等主流文件');
                }
                const isLt2M = file.size / 1024 / 1024 <= 2;
                if (!isLt2M) {
                    this.$message.error('上传文件大小不能超过 2MB!');
                }
                return isFile && isLt2M;
            },
            //上传成功后的下载
            downLoad(url){
                window.open(this.fileHttp + url)
            }

        },
        computed: {
            allowUpload() {
                return this.uploadLoading || !this.Tools.get().StringTools.isNullOrEmpty(this.thisFileUrl)
            }
        }
        ,
        created() {
            this.refName = 'uploadFile' + new Date().getTime()
            if(this.fileType=='file'){
                this.actionUrl = this.$url.uploadfiles
            }else if(this.fileType=='app'){
                this.actionUrl = this.$url.uploadapk
            }
        },
        mounted() {
            this.getConfigUrl().then(res => {
                this.getUserToken()
                this.fileHttp = res
                this.params.path = this.path
            })
        }
    }
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/DialogFile.vue"
}
</vue-filename-injector>
